export const fr = {
  upload: "Télécharger",
  cancel: "Annuler",
  close: "Fermer",
  uploading: "Télécharger...",
  uploaded: "Téléchargé",
  fetching: "Obtenir une image à partir de $1$ ...",
  poweredBy: "Rendu possible par $1$",
  needHelp: "Besoin d'aide?",
  units: {
    px: "px",
    "%": "%",
    deg: "°",
  },
  errors: {
    response_not_ok:
      "Une erreur s'est produite lors de la récupération de ce fichier.",
    unable_to_search: "Une erreur est survenue lors de la recherche",
    invalid_service_url: "Ce n'est pas une URL $1$",
    invalid_url: "Cette URL est invalide",
    upload_aborted: "Votre téléchargement a été annulé",
    upload_error:
      "Une erreur s'est produite lors du téléchargement de ce fichier.",
    file_type_not_allowed: "Ce type de fichier n'est pas supporté",
    file_too_large: "Le fichier doit être inférieur à $1$",
  },
  help: {
    loading: "Aide au chargement...",
    close: "Fermer l'aide",
  },
  services: {
    default: {
      heading: "Sélectionnez une image",
    },
    local: {
      title: "Choisissez un fichier",
      button: "Sélectionnez un fichier",
      or: "de",
      drop: "Faites glisser un fichier ici pour le télécharger",
    },
    camera: {
      title: "Caméra",
      button: "Photo webcam",
      switch: "Changer de caméra",
      waiting: "En attente de la permission de la caméra ...",
      unableToRead:
        "Nous ne pouvons pas lire la vidéo à partir de votre caméra. Cela peut être dû au fait que vous n'avez pas accordé l'autorisation requise ou que votre appareil ne prend pas en charge l'accès à la caméra.",
    },
    microlink: {
      button: "Importation à partir de $1$",
      label: "$1$ $2$ URL",
      placeholder: "Entrez une URL $1$ $2$",
      type: "poster",
    },
    url: {
      title: "Directe URL",
      label: "URL de l'image",
      placeholder: "Entrez une URL d'image",
    },
    instagram: {
      title: "Instagram",
    },
    facebook: {
      title: "Facebook",
    },
    flickr: {
      title: "Flickr",
      type: "une photo",
    },
    ninegag: {
      title: "9GAG",
      type: "une photo",
    },
    deviantart: {
      title: "DeviantArt",
    },
    artstation: {
      title: "ArtStation",
    },
    twitter: {
      title: "Gazouillement",
      type: "photo tweet",
    },
    pinterest: {
      title: "Pinterest",
      type: "épingle",
    },
    flipboard: {
      title: "Flipboard",
      type: "article",
    },
    fotki: {
      title: "Photos",
      type: "une photo",
    },
    linkedin: {
      title: "LinkedIn",
    },
    reddit: {
      title: "Reddit",
    },
    tumblr: {
      title: "Tumblr",
    },
    weheartit: {
      title: "Nous avons le coeur",
    },
    screenshot: {
      title: "Capture d'écran",
      button: "Prendre une capture d'écran",
      label: "URL de la page Web",
      placeholder: "Entrez une URL",
      loading: "Prenez une capture d'écran ...",
    },
    search: {
      button: "Recherche de $1$",
      label: "Rechercher une image",
      placeholder: "Rechercher quelque chose",
      imagesPoweredBy: "Images rendues possibles par $1$",
    },
    giphy: {
      title: "GIPHY",
    },
    unsplash: {
      title: "Unsplash",
    },
    pixabay: {
      title: "Pixabay",
    },
    pexels: {
      title: "Pexels",
    },
  },
  effects: {
    preview: {
      title: "Exemple",
    },
    filters: {
      title: "Les filtres",
    },
    crop: {
      title: "Récolte",
      aspectRatios: {
        free: "Libre",
        square: "Plein",
      },
    },
    rotate: {
      title: "Tournant",
    },
    flip: {
      title: "Faire demi-tour",
      buttons: {
        horizontal: "Horizontal",
        vertical: "Vertical",
      },
    },
    sharpen: {
      title: "Netteté",
    },
    blur: {
      title: "Flou",
    },
    brightness: {
      title: "La luminosité",
    },
    contrast: {
      title: "Contraste",
    },
    grayscale: {
      title: "Niveaux de gris",
    },
    "hue-rotate": {
      title: "Faire pivoter la teinte",
    },
    invert: {
      title: "Retourner",
    },
    saturate: {
      title: "Saturer",
    },
    sepia: {
      title: "Sépia",
    },
  },
};
